import { render, staticRenderFns } from "./starDisplay.vue?vue&type=template&id=8d8b56f8&"
import script from "./starDisplay.vue?vue&type=script&lang=js&"
export * from "./starDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8d8b56f8')) {
      api.createRecord('8d8b56f8', component.options)
    } else {
      api.reload('8d8b56f8', component.options)
    }
    module.hot.accept("./starDisplay.vue?vue&type=template&id=8d8b56f8&", function () {
      api.rerender('8d8b56f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2YsjA50ARBAFA/JS/comp/starDisplay.vue"
export default component.exports